import React, { Component } from "react";
import { SIDE_NAV_ITEMS } from "../../api-constant";
import Sidebar from "../Sidebar/sidebar";
import ResponsiveSidebar from "../Sidebar/Responsive/SideBar";
import NewNavBar from "../NavBar/Navbar";
import SubmitPage from "./SubmitPage";
import axios from "axios";
import addAccessTokenToUrl from "../../Utils/Axios/addTokenToUrl";
import { withRouter } from "react-router";
import ResponsiveSubmitPage from "./Responsive/SubmitPage";
import moment from "moment";
import { toast } from 'react-toastify';
import Navbar from "../../../_components/common/Navbar";


const currentDate = moment().format("YYYY-MM-DD");
const calcWidth = window.innerWidth;

export class Rendersubmitassessment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableNotification: false,
      sidebarOpen: false,
      submitAssessmentDetails: null,
      expiryDate: "",
      nestedModal: false,
      submitAssessmentReport: "",
      isMultiRater: "",
    };
  }

  /* handle api calls */
  componentDidMount() {
    const sentRespondantsId = this.props.match.params.sentRespondantsId;
    const submitAssessment = this.props.match.params.submitAssessment;
    const instrumentType = this.props.match.params.isMultiRater;
    axios
      .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
      .then((response) => {
        const submitAssessmentDetails = response.data.user_assessments.find(
          (specificData) => {
            return specificData.id == sentRespondantsId;
          }
        );
        this.setState({
          submitAssessmentDetails,
          expiryDate: submitAssessmentDetails.expiry_date,
          submitAssessmentReport: submitAssessment,
          isMultiRater: instrumentType,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };
  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };
  handleReportSubmit = () => {
    /* handle report submit api call here */
    const sentRespondantsId = this.props.match.params.sentRespondantsId;
    const participantId = this.props.match.params.idOfParticipant;
    axios
      .post(
        addAccessTokenToUrl("/assessments/submit/user/final/assessments/"),
        {
          user_assessment: sentRespondantsId,
          user: participantId,
        }
      )
      .then((response) => {
        this.setState({
          nestedModal: true,
        });
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast["error"](error.response.data.message, {
            position: toast.POSITION.BOTTOM_LEFT,
            className: "submit-fail",
          });
        } else if (error.request) {
          console.error("No response received");
        } else {
          console.error("Error Message:", error.message);
        }
      });
  };
  handleCloseNotification = () => {
    this.setState({
      enableNotification: false
    })
  }
  render() {
    const userType = localStorage.getItem("usertype");
    return (
      <div>
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? (
          <Navbar />
        ) : (
          <NewNavBar
            enableNotification={this.state.enableNotification}
            handleNotification={this.handleNotification}
            handleCloseNotification={this.handleCloseNotification}
          />
        )}
        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <Sidebar items={SIDE_NAV_ITEMS} />
        ) : null}

        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? null : (
          <ResponsiveSidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
            sidebarOpen={this.state.sidebarOpen}
            onSetSidebarOpen={this.onSetSidebarOpen}
          />
        )}

        {calcWidth <= 767 ? (
          <ResponsiveSubmitPage
            submitAssessmentDetails={this.state.submitAssessmentDetails}
            expired={currentDate > this.state.expiryDate}
            handleReportSubmit={this.handleReportSubmit}
            nestedModal={this.state.nestedModal}
            submitAssessmentReport={this.state.submitAssessmentReport}
            isMultiRater={this.state.isMultiRater}
          />
        ) : (
          <SubmitPage
            submitAssessmentDetails={this.state.submitAssessmentDetails}
            expired={currentDate > this.state.expiryDate}
            handleReportSubmit={this.handleReportSubmit}
            nestedModal={this.state.nestedModal}
            submitAssessmentReport={this.state.submitAssessmentReport}
            isMultiRater={this.state.isMultiRater}
          />
        )}
      </div>
    );
  }
}

export default withRouter(Rendersubmitassessment);



// WEBPACK FOOTER //
// ./src/new/Components/SubmitAssessment/index.jsx